module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("3")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEY SAY THE FIRST STEP")])]), _vm._v(" to any good pastel is to create a solid outline. But it’s really not that easy. Drawing that first line is scary when the paper staring back up at you is so stark. So white and empty. It’s hard to make that first stroke across it, no matter if it’s light or dark, because you’re always afraid of messing it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would have agonized over drawing that stupid upside-down "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("L")]), _vm._v(". No way did I do it and forget. Besides, I don’t even have a subject chosen to draw.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Flipping the light on in the bathroom, I scowl. I’m already on edge because of the mystery mark I found in my sketchpad this morning, and the idea of getting ready in this bathroom isn’t helping. Somehow ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("it looks darker than it did when I was brushing my teeth last night. Creepier. Dingy black-and-white tile dots the floor, and a chipped bathtub that stands on four feet is perched in the corner. There’s only one sink instead of the double we had in Florida, and a murky brown line rings the inside of it.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("How long has it been since someone cleaned this place?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yuck,” I mutter, searching the empty room for a stack of towels. With my luck they aren’t unpacked yet and I’ll have to dry my face on my shirt. Mystery brown lines. No curtains. No towels. I feel like I’m on one of those reality shows where people try to survive the elements. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("And in today’s episode, Tessa Woodward will attempt to survive a nasty bathroom!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I settle for cupping water in my hands and splashing it over my face, careful to keep my hair out of the sink and away from the brown line. Swiping off the extra drops with the palm of my hand, I look in the mirror. My cheeks are flushed and I definitely look more awake. Better than nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m just turning around to head downstairs when the round bulbs above the vanity begin to hum. One at a time, they start to flicker on and off. On and off. On and off.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Weird.")]), _vm._v(" I remember Dad mentioning the leftover ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("furniture and the leak we have to get fixed under the kitchen sink, but I don’t remember him saying anything about electrical problems in this place.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A deep crackling sound echoes off the bare walls and my arms break out in goose bumps. Within seconds, it’s all around me, like it’s somehow leaking into the room from an invisible crack. I turn a full circle to see if I can figure out where it’s coming from, freezing in my tracks as all four of the lightbulbs go dim, leaving me in near-darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aaaand, that’s my cue. I head for the door, grab the doorknob and turn, but nothing happens. It won’t budge. As I scan the metal plate around the knob, my hand begins shaking. There’s no lock on this door. So why won’t it turn?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom?” I shout through the door, gasping as the lights dim even further. It’s dark enough that I can barely make out the shadow of my own hand in front of me as I wrench at the door, kicking and clawing at the warped wood in an attempt to free myself. The crackling gets louder, filling my ears with something that sounds like terrifying raw electricity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("I finally slide down onto the floor and cover my ears. The sound is so loud that it feels like it’s going through my skin and into my body. I blink at the ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("darkness but see nothing. I’m not sure if I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("want")]), _vm._v(" to see something at this point.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A sharp pain catches me in the ribs. I scream and scamper away from the door and into the opposite corner of the bathroom. Whatever has trapped me in this bathroom is definitely attacking. The lights flip on and my mom’s face appears. Her lips are moving, but I can’t hear anything. Nothing but the crackling, that is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She reaches out and gently removes my hands from my ears. The noise stops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tessa? Oh, honey, what happened?” she says, pulling me in close. I feel her arms wrapping around me and lay my head against her chest, telling myself to calm down and stop being such a baby. “Did I hit you when I opened the door?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The lights,” I sputter out. “They were flickering and there was this sound—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those lights?” Mom asks, cutting me off. She’s pointing to the bulbs over the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod. “Yeah, they almost went all the way out. All four of them! And the noise was loud—like a hissing and crackling sound.” I look around at the walls but see nothing other than uneven color and a mess of cracked paint. No gaping holes where crackling creatures tried to force their way in. “I don’t know where it was coming from, though.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Mom untangles herself from me and stands. She looks at the light switch and then down at me. Holding out a hand, she helps me to my feet. “I’m no expert on old houses, but I think there might be a simple explanation for both of those things.”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I tilt my head at her, curious. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gestures to the light switch. “See how the switch is halfway between on and off? I’m willing to bet that these Victorian houses have some pretty finicky electrical systems and maybe that was what caused all the flickering lights.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stare at the light switch. It "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" frozen between the on and off position. “Did I almost burn down the house or something? I mean, the sound was really scary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom laughs, a quiet sort of giggle that warms my heart. “Nah. I don’t think you did any damage at all. Just scared yourself a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Exhaling a shaky breath, I try for a smile. I know it’s weak, but it’s all I’ve got. I’m about to walk out when I remember the doorknob. Finicky electrical systems can’t explain that. Are the doors really so old in this house that they don’t open properly?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The door was stuck, too. That’s why I was calling for you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("She looks confused. Her bright eyes linger on me for a moment longer than usual before she shrugs. ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“I didn’t hear you calling me. Honestly, it was pure coincidence that I walked in here. I needed to brush my teeth.” She lifts up her left hand to reveal the cosmetic bag she’s holding.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t hear "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("anything")]), _vm._v("?” I say, stunned. “Not the loud sounds or me screaming? Nothing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom shakes her head. “I’m sorry, sweetie. The real estate agent said no one builds houses like these anymore because the materials were too good. Too expensive.” She knocks on the door as proof. “Hear that? This is a solid wooden door. Not hollow. Everything is just thicker than in newer constructions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remind me that if I’m ever going to fall down or hit my head or pass out, I should try to do it in a room with an open door. Jeez. I turn back and face the mirror. All the pink has drained from my face, leaving behind an ashen-white mask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You going to be okay?” Mom puts her hands on my shoulders and gives a squeeze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nodding, I try to shake off the fear. I am okay. If I could survive the trip and the first day here, I can survive this creepy old bathroom.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 66
// module chunks = 0